import { render, staticRenderFns } from "./digitalplanlector.vue?vue&type=template&id=4c780f8e"
import script from "./digitalplanlector.vue?vue&type=script&lang=js"
export * from "./digitalplanlector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports